module.exports = __webpack_public_path__ + "static/media/greenhouse.0581b50e.svg";